import { PlanDataPoint } from './vessel-performance-model-impl';
import { VoyagePlan } from './vessel-planning-model';
import { VoyageRouteLineFeature, VoyageRoutePointFeature } from './voyage-routing-model';

export { VoyagePlan };

export interface VesselConfigData
{
    maxPower: number; // in kW
    maxRpm: number;
    maxSpeed: number;
}

export interface SimulatedValue {
    value: number;
    lower?: number;
    upper?: number;
}

export interface LegData {
    title: string;
    unit: string;
    current?: number|null;
    nextLeg: number|null;
    simulated: SimulatedValue|null;
    max?: number;
}

export interface LegInfo {
    nextLegWaypointDetails: string;
    etaBasedOnCurrentSpeed: Date | null;
    distance: number;
    distanceToPilot: number | null;
    timeToPilotTs: number | null;
    timeToPilotEta: number | null;
    pilotTimestamp: Date | null;
    avgSpeedToPilotEta: number | null;
}

export interface CurrentLeg
{
    MEPower: LegData;
    RPM: LegData;
    SOG: LegData;
    STW: LegData;
    RollAngle: LegData;

    info: LegInfo;
}

export interface RemainingDataToPilot {
    distanceToPilot: number | null;
    timeToPilotEta: number | null;
    avgSpeedToPilotEta: number | null;
}

export interface RemainingDataToBerth {
    distanceToBerth: number | null;
    timeToBerthEta: number | null;
    avgSpeedToBerthEta: number | null;
}

export type PerfDataSetName = "current" | "route1" | "route2" | "route3" | '';

export enum ParameterType
{
    SpeedOverGround, // in knots
    PropulsionPower, // in KW
    RPM,
    SpeedThroughWater, // in knots
    CurrentImpact, // in knots
    RollAngle
}

export interface ParameterValue
{
    timestamp: number;
    value: number;
    lower?: number;
    upper?: number;
}

export abstract class VesselPerformanceModelBase extends EventTarget
{
    abstract getConfigurationData(): Promise<VesselConfigData|null>;
    abstract getLegData(date: Date, dataSetName: PerfDataSetName): Promise<CurrentLeg>;
    abstract getCurrentLegData(): CurrentLeg|null;
    abstract getRemainingDataToPilot(): RemainingDataToPilot|null;
    abstract getRemainingDataToBerth(): RemainingDataToBerth|null;
    abstract syncData(fromDate: Date, toDate: Date, plan: VoyagePlan): Promise<void>;
    abstract extractOneParam(dataSet: PerfDataSetName, type: ParameterType, onlyPositiveValues?: boolean, etaChange?: boolean, requestedPlanData?: PlanDataPoint[]): ParameterValue[];
    abstract extractOnePAPIParam(type: ParameterType, onlyPositiveValues?: boolean): ParameterValue[];
    abstract createDataSet(route_geometry: Array<VoyageRoutePointFeature|VoyageRouteLineFeature>): PlanDataPoint[];
    abstract syncUiRoutesData(): void;
}

let VesselPerformanceModel: VesselPerformanceModelBase|null = null;

function setVesselPerformanceModel(model: VesselPerformanceModelBase)
{
    VesselPerformanceModel = model;
}

export { VesselPerformanceModel, setVesselPerformanceModel };
